module.exports = __webpack_public_path__ + "img/h.167ec09d.png";